import React from 'react';
import { MARKET_PRICES, CURRENT_RATES } from '../constants/pricing';

const PositionOverviewModal = ({ isOpen, onClose, userNICP }) => {
  if (!isOpen) return null;

  const currentValue = userNICP * MARKET_PRICES.nICP;
  const delayedUnstakeValue = userNICP * 1.14; // 14% gain after 6 months
  const delayedUnstakeUSD = delayedUnstakeValue * MARKET_PRICES.ICP;

  const immediateSwapValue = userNICP * 0.9955; // Market swap with 0.45% slippage
  const immediateSwapUSD = immediateSwapValue * MARKET_PRICES.ICP;

  return (
    <div className="modal-overlay">
      <div className="position-overview-modal">
        <div className="modal-header">
          <h2 className="modal-title">Unstake with Delay Overview</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Position Summary */}
          <div className="position-summary">
            <div className="position-icon">💧</div>
            <div className="position-info">
              <h3>{userNICP.toFixed(2)} nICP</h3>
              <span className="position-value">${currentValue.toFixed(2)}</span>
            </div>
          </div>

          {/* Comparison Overview */}
          <div className="comparison-section">
            <h4>Choose Your Exit Strategy</h4>
            <div className="options-comparison">
              <div className="option-card immediate">
                <div className="option-header">
                  <h5>Swap on Market</h5>
                  <span className="time-badge instant">Instant</span>
                </div>
                <div className="option-value">
                  <span className="amount">{immediateSwapValue.toFixed(2)} ICP</span>
                  <span className="usd-value">${immediateSwapUSD.toFixed(2)}</span>
                </div>
                <div className="option-details">
                  <div className="detail-item">
                    <span className="label">Market rate:</span>
                    <span className="value">1 nICP = {(1/CURRENT_RATES.nIcpPerIcp).toFixed(3)} ICP</span>
                  </div>
                  <div className="detail-item">
                    <span className="label">Fees/Slippage:</span>
                    <span className="value">~0.45%</span>
                  </div>
                </div>
              </div>

              <div className="option-card delayed">
                <div className="option-header">
                  <h5>Unstake with Delay</h5>
                  <span className="time-badge delay">~6 months</span>
                </div>
                <div className="option-value">
                  <span className="amount">{delayedUnstakeValue.toFixed(2)} ICP</span>
                  <span className="usd-value">${delayedUnstakeUSD.toFixed(2)}</span>
                </div>
                <div className="option-details">
                  <div className="detail-item">
                    <span className="label">Protocol rate:</span>
                    <span className="value">NAV + rewards</span>
                  </div>
                  <div className="detail-item">
                    <span className="label">Additional gain:</span>
                    <span className="value green">+{(delayedUnstakeValue - immediateSwapValue).toFixed(2)} ICP</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Key Insights */}
          <div className="insights-section">
            <div className="insight-card">
              <h5>💰 Potential Gain</h5>
              <p>By choosing delayed unstaking, you could gain an additional <strong>{(delayedUnstakeValue - immediateSwapValue).toFixed(2)} ICP</strong> (~${((delayedUnstakeValue - immediateSwapValue) * MARKET_PRICES.ICP).toFixed(0)}) compared to immediate market swap.</p>
            </div>
            
            <div className="insight-card">
              <h5>⏰ Time vs Value</h5>
              <p>The delayed option provides guaranteed protocol redemption at full NAV plus accumulated rewards, while market swap gives instant liquidity at current market rates.</p>
            </div>
          </div>

          {/* Process Information */}
          <div className="details-section">
            <h4>Unstaking Process</h4>
            <div className="process-steps">
              <div className="step">
                <span className="step-number">1</span>
                <div className="step-content">
                  <h6>Initiate Unstaking</h6>
                  <p>Your nICP tokens are burned and added to withdrawal queue</p>
                </div>
              </div>
              <div className="step">
                <span className="step-number">2</span>
                <div className="step-content">
                  <h6>Dissolvement Period</h6>
                  <p>Wait ~6 months for neuron dissolvement (rewards continue accruing)</p>
                </div>
              </div>
              <div className="step">
                <span className="step-number">3</span>
                <div className="step-content">
                  <h6>Receive ICP</h6>
                  <p>Get your ICP + accumulated rewards directly to your wallet</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button 
            className="action-button secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="action-button primary"
            onClick={() => {
              alert('Proceeding with delayed unstaking...');
              onClose();
            }}
          >
            Proceed with Unstaking
          </button>
        </div>
      </div>
    </div>
  );
};

export default PositionOverviewModal;
